import { forwardRef } from 'react';
import styled from 'styled-components';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import { MediaImage } from '@elfsight/widget-media';
import { useFiltersTheme } from '../../filters-theme-provider';
import type { BaseButtonProps } from '../buttons';
import { BaseButton } from '../buttons';

export type TagImageButtonProps = Omit<
  BaseButtonProps,
  'rightSlot' | 'leftSlot'
> & {
  imageSrc?: string;
};

export const TagImageButton = forwardRef<
  HTMLButtonElement,
  TagImageButtonProps
>(
  (
    { children, imageSrc, borderRadius = 32, ...forwardingProps },
    forwardingRef
  ) => {
    const { textColor } = useFiltersTheme();

    return (
      <Button
        {...forwardingProps}
        borderRadius={borderRadius}
        leftSlot={
          <Media
            containerWidth="32px"
            containerHeight="32px"
            src={imageSrc}
            alt={children?.toString()}
            withSkeleton
            skeletonColor={getColorWithAlpha(textColor, 0.1)}
          />
        }
        ref={forwardingRef}
      >
        {children}
      </Button>
    );
  }
);

const Button = styled(BaseButton)`
  min-height: 48px;
  &:active {
    transform: scale(0.9);
  }
`;

const Media = styled(MediaImage)`
  border-radius: 100%;
  flex-shrink: 0;
  flex-direction: column;
  align-items: flex-start;
  aspect-ratio: 1/1;
  margin-left: -8px !important;
`;
